<!--
  ~ Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
  ~ This software is the proprietary information of Irian Software Development SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class='ui-blockui' *ngIf='blockUi$ | async' irianPreventKeyPress irianPreventScrollDirective>
  <div class='loading-icon'>
    <i class='fa-solid fa-circle-notch fa-spin'></i>
  </div>
</div>
